import React from 'react';

const ShowcaseHeader = props => {
  return <div className="showcaseHeader description">{props.description}</div>;
};

export default ShowcaseHeader;
